export default {
  UPDATE_TOTALS (state, totals) {
    state.totalProjects = totals.total_projects || 0
    state.totalKeywords = totals.total_keywords || 0
    state.totalLinks = totals.total_links || 0
    state.totalReports = totals.total_reports || 0
    state.totalProxies = totals.total_proxies || 0
    state.totalUsers = totals.total_users || 0
    state.totalGoals = totals.total_goals || 0
  },
  UPDATE_TOTALS_FROM_USER (state, user) {
    state.totalProjects = user.projects_count || 0
    state.totalKeywords = user.keywords_count || 0
    state.totalLinks = user.links_count || 0
    state.totalReports = user.reports_count || 0
    state.totalGoals = user.goals_count || 0
  },
  SET_METADATA (state, {origin, formated}) {
    state.userRoles = origin.user_roles
    state.engines = origin.engines
    state.reports = origin.reports
    state.enginesById = formated.enginesById
    state.reportsById = formated.reportsById
    state.selectEngines = formated.selectEngines
    state.selectUserRoles = formated.userRoles
  },
  SET_WINDOW_SIZE (state, {width, height}) {
    state.windowWidth = width
    state.windowHeight = height
  }
}



// WEBPACK FOOTER //
// ./src/store/metadata/mutations.js